import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import type { Pagination } from 'commons/modules/pagination';

import type { AlertValues } from 'views/Alerts/models/alert';

import type { AlertsStoreType } from './types/alerts-store';

import type { RootState } from './configureStore';

const initialState: AlertsStoreType = {
  aletsData: [],
  showAlertsModal: false,
  showNewAlertNotification: false,
  pagination: {
    pageSize: 10,
    page: 0,
  },
};

export const slice = createSlice({
  name: 'alerts',
  initialState: { ...initialState },
  reducers: {
    setAletsData: (alerts, action: PayloadAction<AlertValues[]>) => {
      alerts.aletsData = action.payload;
    },
    setShowAlertsModal: (alerts, action: PayloadAction<boolean>) => {
      alerts.showAlertsModal = action.payload;
    },
    setShowNewAlertNotification: (alerts, action: PayloadAction<boolean>) => {
      alerts.showNewAlertNotification = action.payload;
    },
    setPagination: (alerts, action: PayloadAction<Pagination>) => {
      alerts.pagination = action.payload;
    },
    cleanData: () => initialState,
  },
});

export const {
  setAletsData,
  setShowAlertsModal,
  setShowNewAlertNotification,
  setPagination,
  cleanData,
} = slice.actions;

export default slice.reducer;

// Selectors
export const getAletsData = (state: RootState) =>
  state.entities.alerts.aletsData;
export const getShowAlertsModal = (state: RootState) =>
  state.entities.alerts.showAlertsModal;
export const getShowNewAlertNotification = (state: RootState) =>
  state.entities.alerts.showNewAlertNotification;
export const getPagination = (state: RootState) =>
  state.entities.alerts.pagination;
